import { useContext } from 'react';
import { createContext } from 'react';

import { HeaderProps } from '../@types/HeaderProps';

export const HeaderContext = createContext<HeaderProps>({} as HeaderProps);

HeaderContext.displayName = 'Header';

const HeaderProvider = (props: HeaderProps) => (
	<HeaderContext.Provider value={props}>{props.children}</HeaderContext.Provider>
);

export const useHeader = () => {
	const context = useContext(HeaderContext);

	return context;
};

export default HeaderProvider;
